import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { CereriService } from 'src/app/components/cereri/cereri.service';
import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { environment } from 'src/environments/environment';
import { Observable, Subject, finalize, map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/utils/dialog.service';
import { StatusService } from 'src/app/platform/nomenclatoare/status-cerere/status.service';
import { initializeEditor } from 'src/app/utils/storage/editorConfig';
import { Generic, GenericStatusCerere } from 'src/app/interfaces/generic.interface';
import { DataTableDirective } from 'angular-datatables';
import { helper } from 'src/environments/helper';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import * as $ from 'jquery';
import { FormControl, FormGroup } from '@angular/forms';
import { MatCalendar } from '@angular/material/datepicker';
import { Cerere } from './cerere.interface';
import { CereriAsigneazaComponent } from './cereri-asigneaza/cereri-asigneaza.component';
import { CereriStatusComponent } from './cereri-status/cereri-status.component';
import { NotificationService } from 'src/app/services/notification.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { Router } from '@angular/router';
import { AppFilesService } from 'src/app/services/app-files.service';
import { RegistreService } from 'src/app/platform/nomenclatoare/registre/registre.service';

@Component({
    selector: 'app-cereri',
    templateUrl: './cereri.component.html',
    styleUrls: ['./cereri.component.scss'],
})
export class CereriComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    helper = helper;
    editorConfig!: AngularEditorConfig;
    selectedAddressType = '-1';
    isLoading = false;
    isFilterLoading = false;
    showCard = false;
    checkboxSelections = false;
    judete!: Generic[];

    selectedFiltre = 'simple';

    selectedArhivaID = 0;

    // Popover dates

    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(2018, 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = '';
    directii!: Generic[];
    compatimente!: Generic[];
    statusCerere!: GenericStatusCerere[];
    statusuriFiltered!: GenericStatusCerere[];
    registre!: Generic[];
    compartimente!: any;
    compartimenteResponsabil!: any;

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.today);
        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedEndDate = new Date(year, 11, 31);
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.rerenderDT();
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    // Date popover filtering

    dateFilteringOptions: { id: number; value: string }[] = [
        { id: 1, value: 'Adăugare' },
        { id: 2, value: 'Actualizare' },
        { id: 3, value: 'Validare' },
        { id: 4, value: 'Invalidare/Anulare' },
        { id: 5, value: 'Finalizare' },
    ];

    dateFilterOption: number = 1;

    statusParametersValue!: string;
    categoryParametersValue!: string;
    notificationParameter: { id: string; name: string } = { id: '-1', name: '' };

    // Values for status filtering

    defaultParameter: { name: string; id: string } = {
        name: 'Toate',
        id: '-1',
    };

    filterParameter: { name: string; id: string } = {
        name: '-- Alegeți --',
        id: '-1',
    };

    // Vaue for status filtering
    selectedStatusID: string = this.defaultParameter.id;

    // Values for category filtering
    categoryToggleOptions = [
        { id: -1, value: 'Toate' },
        { id: 1, value: 'De aprobat' },
        { id: 2, value: 'Departamentele mele' },
        { id: 3, value: 'Cererile mele' },
        { id: 4, value: 'Mesaje interne' },
    ];

    selectedCategory: string | number = this.categoryToggleOptions[0].id;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    requestTypes$!: Observable<Generic[]>;
    operatori$!: Observable<Generic[]>;
    requestStatuses$!: Observable<Generic[]>;
    directiiActive$!: Observable<Generic[]>;
    compartimenteActive$!: Observable<Generic[]>;

    parameters: { key: string; value: string }[] = [
        { key: '-- Alegeți --', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    address_type: { key: string; value: string }[] = [
        { key: '-- Alegeți --', value: '-1' },
        { key: 'Domiciliu/Reședință', value: '1' },
        { key: 'Sediu', value: '2' },
        { key: 'Beneficiar', value: '3' },
    ];

    toggleCard() {
        this.showCard = !this.showCard;
        this.selectedFiltre = 'simple';
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    toggleArhiva() {
        this.selectedArhivaID = this.selectedArhivaID === 0 ? 1 : 0;
        this.selectedStatusID = this.defaultParameter.id;
        this.filterRequestStatuses(this.statusCerere, this.selectedArhivaID);

        this.rerenderDT();
    }

    searchParamsForm!: FormGroup;

    filterCount: number = 0;

    //Form Initial Values

    initialFormValues = {
        numarCerere: '',
        numarCerereIntern: '',
        cnp_cui: '',
        cetatean_pj: '',
        telefon: '',
        email: '',
        check_adresa_proprietate: false,
        numar_cadastral: '',
        proprietate_strada: '',
        proprietate_numar: '',
        proprietate_scara: '',
        proprietate_bloc: '',
        proprietate_etaj: '',
        proprietate_apartament: '',
        proprietate_observatii: '',
        tip_adresa: '-1',
        judet: '-1',
        city: '',
        streetName: '',
        streetNumber: '',
        compartimentValue: '-1',
        cerere_types: '-1',
        registru_types: '-1',
        numarRegistru: '',
        compartimentResponsabil: '-1',
        operator: '',
        status_validat: '-1',
        status_invalidat: '-1',
        status_clasat: '-1',
        status_finalizat: '-1',
    };

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            numarCerere: new FormControl(''),
            numarCerereIntern: new FormControl(''),
            cnp_cui: new FormControl(''),
            cetatean_pj: new FormControl(''),
            telefon: new FormControl(''),
            email: new FormControl(''),
            check_adresa_proprietate: new FormControl(false),
            numar_cadastral: new FormControl(''),
            proprietate_strada: new FormControl(''),
            proprietate_numar: new FormControl(''),
            proprietate_scara: new FormControl(''),
            proprietate_bloc: new FormControl(''),
            proprietate_etaj: new FormControl(''),
            proprietate_apartament: new FormControl(''),
            proprietate_observatii: new FormControl(''),
            tip_adresa: new FormControl('-1'),
            judet: new FormControl('-1'),
            city: new FormControl(''),
            streetName: new FormControl(''),
            streetNumber: new FormControl(''),
            compartimentValue: new FormControl('-1'),
            cerere_types: new FormControl('-1'),
            registru_types: new FormControl('-1'),
            numarRegistru: new FormControl(''),
            compartimentResponsabil: new FormControl('-1'),
            operator: new FormControl(''),
            status_validat: new FormControl('-1'),
            status_invalidat: new FormControl('-1'),
            status_clasat: new FormControl('-1'),
            status_finalizat: new FormControl('-1'),
        });
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.selectedAddressType = '-1';
        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT();
    }

    // Info for conditional assign and change status from DT

    selectedRowIds: number[] = [];

    rowCount = 0;

    dtLink =
        environment.interop.basePath +
        environment.interop.urbanism.cerere.getCereriListDT;

    notificationServiceBefore: any = {
        currentStatus: -1,
        currentCategory: -1,
    }

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private cereriService: CereriService,
        private cerereStatusService: StatusService,
        private registreService: RegistreService,
        private notificationService: NotificationService,
        public permissionsService: PermissionsService,
        private router: Router,
        private appFileService: AppFilesService,
    ) {
        this.tomorrow.setDate(this.today.getDate() + 1);
    }

    ngOnInit(): void {
        this.renderDT();
        this.loadRequestStatuses();
        this.loadRegistre();
        this.loadJudete();
        this.loadDirectiiActive();
        this.loadCompartimente();
        this.editorConfig = initializeEditor();
        this.buildSearchParamsForm();
        this.redirectFromNotifications();
        this.filterCategoryOptions();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    redirectFromNotifications() {
        this.notificationService.currentNotification.subscribe(
            (notification: { id: string; name: string }) => {
                if (notification) {
                    this.notificationParameter = notification;
                    // here we need to update our buttons
                    this.notificationServiceBefore.currentStatus = this.selectedStatusID;
                    this.notificationServiceBefore.currentCategory = this.selectedCategory;

                    this.selectedStatusID = '-1';
                    this.selectedCategory = -1;

                    this.rerenderDT();
                }
            }
        );
    }

    removeChip(): void {
        // Resets the notification parameter which we send to our backend with -1 so the filter for this particular flag is canceled
        this.notificationParameter = { id: '-1', name: '' };

        // here we need to update our buttons
        this.selectedStatusID = this.notificationServiceBefore.currentStatus;
        this.selectedCategory = this.notificationServiceBefore.currentCategory;

        this.rerenderDT();
    }

    loadRegistre() {
        this.isFilterLoading = true;
        this.registreService
            .getRegistre()
            .pipe(
                map((results: any) => [this.filterParameter, ...results]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.registre = results;
                },
                error: (error) => {
                    console.error('Error loading registre', error);
                    this.isFilterLoading = false;
                }
            })
    }

    loadJudete() {
        this.cereriService
            .getJudete()
            .pipe(
                map((results: any) => [this.filterParameter, ...results]))
            .subscribe({
                next: (results) => {
                    this.judete = results;
                },
                error: (error) => {
                    console.error('Error loading judete', error);
                }
            })
    }

    loadDirectiiActive() {
        this.cereriService
            .getDirectii()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]))
            .subscribe({
                next: (results) => {
                    this.directii = results;
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                },
            });
    }

    loadCompartimente() {
        this.isFilterLoading = true;
        this.cereriService
            .getCompartimenteByUrbanism()
            .pipe(
                map((results: any) => [this.filterParameter, ...results]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.compartimente = this.compartimenteResponsabil = results;
                },
                error: (error) => {
                    console.error('Error loading compartimente', error);
                    this.isFilterLoading = false;
                },
            });
    }

    onCompartimenteChange(compartimentId: number): void {
        if (compartimentId) {
            this.loadRequestTypes(compartimentId);
        } else {
            this.requestTypes$ = new Observable<Generic[]>((observer) => {
                observer.complete();
            });
        }
    }

    onCompartimenteResponsabilChange(compartimentId: number): void {
        if (compartimentId) {
            this.loadOperatori(compartimentId);
        } else {
            this.operatori$ = new Observable<Generic[]>((observer) => {
                observer.complete();
            });
        }
    }

    loadRequestTypes(compartimentId: number) {
        this.isFilterLoading = true;
        this.requestTypes$ = this.cereriService
            .getRequestTypes(compartimentId)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => {
                    this.isFilterLoading = false;
                })
            );
    }

    loadOperatori(compartimentId: number) {
        this.isFilterLoading = true;
        this.operatori$ = this.cereriService
            .getOperatoriByCompartiment(compartimentId)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => {
                    this.isFilterLoading = false;
                })
            );
    }

    loadCompartimenteActive(directieId?: number) {
        this.isFilterLoading = true;
        let compartimenteObservable$ = directieId
            ? this.cereriService.getCompartimenteByDirectieId(directieId)
            : this.cereriService.getCompartimenteActive();

        this.compartimenteActive$ = compartimenteObservable$.pipe(
            map((results: any) => [this.filterParameter, ...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        );
    }

    loadRequestStatuses() {
        this.isFilterLoading = true;
        this.cerereStatusService
            .getCerereStatuses()
            .pipe(
                map((results: any) => [...results, this.defaultParameter]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.statusCerere = results;
                    this.filterRequestStatuses(this.statusCerere, this.selectedArhivaID);
                },
                error: (error) => {
                    console.error('Error loading request statuses', error);
                    this.isFilterLoading = false;
                },
            });
    }

    filterRequestStatuses(statusuri: GenericStatusCerere[], archiveId: number) {
        const archiveType = archiveId === 0 ? false : true;
        this.statusuriFiltered = statusuri.filter(status => {
            return (status.archive === archiveType || status.name === "Toate")
        })
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    renderDT() {
        const self = this;
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[1, 'desc']],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                dataTablesParameters.status = this.selectedStatusID;
                dataTablesParameters.categoryStatus = this.selectedCategory;
                dataTablesParameters.filters = {
                    ...this.searchParamsForm.value,
                    archive: this.selectedArhivaID
                };
                dataTablesParameters.dateFilter = +this.dateFilterOption;
                dataTablesParameters.date_from = this.formatDate(
                    this.selectedStartDate
                );
                dataTablesParameters.date_to = this.formatDate(this.selectedEndDate);
                dataTablesParameters.notificationParameter =
                    this.notificationParameter.id;

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        this.getTableRowCount();
                        this.checkboxesReset();
                        this.filterCount = resp.data.filterCount;

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                { width: '30px', targets: 0 },
                { width: '150px', targets: 1 },
            ],

            columns: [
                {
                    title: `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" id="headerCheckbox"/>`,
                    data: 'id_cerere',
                    className: 'all',
                    render: (data: any, type: any, row: any) => {
                        return `
							<div style="display: flex; align-items: center; gap: 5px;">
								<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" value="${row.id_cerere
                            }" />
							</div>
						`;
                    },
                },
                {
                    title: `Registratura / Cerere`,
                    data: 'id_cerere',
                    className: 'all',
                    render: (data: any, type: any, row: any) => {
                        let flagIcon =
                            '<i class="fa-solid fa-flag" style="color: white;"></i> ';

                        return `
							<div style="display: flex; align-items: center; gap: 5px;">
								<span>${row.indoc_number ? row.indoc_number : 'N/A'}</span>
								<span>/</span>
								<span>${row.created}</span>
								</div>
								<div> <br/>
									<span  style="padding: 5px; background-color: #bdbdbd; border: 0px;border-radius:5px">I: ${row.id_cerere}</span>
								</div>
							` + (row.mesajeInterne == 1 ?
                                `<div> <br/><span  style="padding: 4px 6px; color: white; background-color: red; border: 0px;border-radius:10px">${flagIcon} Mesaj intern</span>
									</div>`
                                : '')
                            + `
						`;
                    },
                },
                {
                    title: 'Tip Cerere',
                    data: 'subject',
                    sortable: false,

                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-addcard.svg';
                        const imageTreeUrl = '/assets/icons/icon-tree.svg';
                        return `
							<span><strong>${row.subject}</strong></span><br/><br/>
							<span style="color:#bdbdbd; font-size:12px"> Categorie / Tip</span><br/>
							<span>
							<img src="${imageUrl}" alt="Image" style="width: 20px; height: 20px;">
							${row.categorie_directie} <br/>
							<img src="${imageTreeUrl}" alt="Image" style="width: 20px; height: 20px;">
							${row.categorie_compartiment}</span><br/><br/>
						`;
                    },
                },
                {
                    title: 'Identificare',
                    data: 'denumire_cetatean',
                    sortable: false,
                    className: 'all',
                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-user.svg';
                        return `
						<span style="color:#bdbdbd; font-size:12px"> Cetățean/Societate</span><br/>
						<img src="${imageUrl}" alt="Image" style="width: 20px; height: 20px;">
						<span>${row.denumire_cetatean}</span><br/> <hr/>
                        <span style="color:#bdbdbd; font-size:12px"> Beneficiar(i)</span><br/>
						<img src="${imageUrl}" alt="Image" style="width: 20px; height: 20px;">
						<span>${row.denumire_beneficiar}</span><br/> <hr/>
						${row.adresa}
						`;
                    },
                },
                {
                    title: 'Atribuire',
                    data: 'user_assigned',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-addcard.svg';
                        const imageTreeUrl = '/assets/icons/icon-tree.svg';

                        return `
							<span style="color:#bdbdbd; font-size:12px">Locație Solicitare</span><br/>
							<span style="color:#bdbdbd; font-size:12px">Instituție</span><br/>
							<span style="font-weight:600 font-size:16px">${row.directie}</span><br/>
							<span style="color:#bdbdbd; font-size:12px">Serviciu/Birou/Departament</span><br/>
							<span>${row.compartiment}</span><br/>
							<span style="color:#bdbdbd; font-size:12px">Operator Asignat</span><br/>
							<span>${row.user_assigned}</span>
						`;
                    },
                },
                {
                    title: 'Prioritate',
                    data: 'sla',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
							<span style="border-radius:10px; padding:4px 8px; color: ${row.priority_color}; background: ${row.priority_bg_color}">${row.priority_name}</span><br/><br/>
							<span style="color:#bdbdbd; font-size:12px">SLA</span><br/>
							<span>${row.sla}</span><br/>
						`;
                    },
                },
                {
                    title: 'Soluționare',
                    data: 'solutionare',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `${data} `;
                    },
                },
                {
                    title: 'Status',
                    data: 'updated_at',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        let label = '';
                        let flagIcon =
                            '<i class="fa-solid fa-flag" style="color: white;"></i> ';
                        if (row.validated_date && !row.cancel_date) {
                            // Validat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: green">${flagIcon}Validat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 1) {
                            // Invalidat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: orange">${flagIcon}Invalidat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 2) {
                            // Clasat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: red">${flagIcon}Clasat</span>`;
                        } else {
                            // Default case
                            label = ``;
                        }
                        return `
							<span style="border-radius:10px; padding:4px 8px; color: ${row.status_color}; background: ${row.status_bg_color}">${row.status_name}</span><br/><br/>
							<span style="color:#bdbdbd; font-size:12px">Ultima actualizare</span><br/>
							<span>${row.updated}</span><br/>
              				<br/>${label}
						`;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                // Handle click event on the CHECKBOXES
                $(row)
                    .find('.row-checkbox')
                    .off('change')
                    .on('change', function () {
                        let idCerere = Number($(this).val());

                        if ($(this).is(':checked')) {
                            self.selectedRowIds.push(idCerere);
                        } else {
                            self.selectedRowIds = self.selectedRowIds.filter(
                                (id) => id !== idCerere
                            );
                        }

                        if (self.rowCount !== self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(false);
                        } else if (self.rowCount === self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(true);
                        }

                        self.checkboxSelections = self.selectedRowIds.length > 0;
                    });

                $('td:not(:first-child)', row).on('click', () => {
                    this.onRowClick(data);
                });

                return row;
            },
            headerCallback: (row: Node, data: any[] | any) => {
                const headerCheckbox = $(row).find('#headerCheckbox');

                // Remove any existing event handlers to avoid duplicating them
                headerCheckbox.off('change click');

                // Handle the change event for selecting/deselecting all checkboxes
                headerCheckbox.on('change', function () {
                    if ($(this).is(':checked')) {
                        self.selectedRowIds.length = 0;
                        data.forEach((item: Cerere) => {
                            self.selectedRowIds.push(item.id_cerere);
                        });
                        self.checkMultipleCheckboxesByValue(true);
                    } else {
                        self.selectedRowIds.length = 0;
                        self.checkMultipleCheckboxesByValue(false);
                    }
                    self.checkboxSelections = self.selectedRowIds.length > 0;
                });

                // Prevent sorting when clicking the checkbox
                headerCheckbox.on('click', function (e) {
                    e.stopPropagation();
                });

                return row;
            },
        };
    }

    async getTableRowCount() {
        const table = await this.dtElement.dtInstance;
        this.rowCount = table.rows().count();
    }

    checkHeaderCheckBox(checkValue: boolean) {
        const headerCheckbox = document.getElementById(
            'headerCheckbox'
        ) as HTMLInputElement;
        headerCheckbox.checked = checkValue;
    }
    checkMultipleCheckboxesByValue(checkValue: boolean) {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[type="checkbox"]'
        );
        checkboxes.forEach((checkbox) => {
            checkbox.checked = checkValue;
        });
    }
    checkboxesReset() {
        this.selectedRowIds.length = 0;
        this.checkMultipleCheckboxesByValue(false);
        this.checkHeaderCheckBox(false);
        this.checkboxSelections = false;
    }

    onRowClick(rowData: Request) {
        this.openInfoDialog(rowData);
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });
    }

    openInfoDialog(data: any) {
        const dialogRef = this.dialog.open(CereriDetaliiComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data: {
                cerere: data,
                directii: this.directii,
                statusCerere: this.statusCerere,
            },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            this.rerenderDT();
        });
    }

    onStatusChange(event: MatButtonToggleChange) {
        this.isLoading = true;
        this.selectedStatusID = event.value;

        this.statusParametersValue = event.value === 'toate' ? '-1' : '1';
        this.rerenderDT();
    }

    onCategoryChange(event: MatButtonToggleChange) {
        this.isLoading = true; // Assuming you have an isLoading flag for loading state
        this.selectedCategory = event.value;

        const selectedOption = this.categoryToggleOptions.find(option => option.id === event.value);
        this.categoryParametersValue = selectedOption ? selectedOption.value : 'default';
        this.rerenderDT();
    }


    filterCategoryOptions() {
        const permissionMapping: { [key: string]: string } = {
            "-1": "urbanism-module.solicitari.view.list-all",
            "1": "urbanism-module.solicitari.view.to-approve",
            "2": "urbanism-module.solicitari.view.list-my-departments",
            "3": "urbanism-module.solicitari.view.list-my-requests", // nu vine nimic din backend momentan
            "4": "urbanism-module.solicitari.view.list-intern-messages",
        };

        // Filter categoryToggleOptions based on permissions
        this.categoryToggleOptions = this.categoryToggleOptions.filter(option =>
            this.permissionsService.hasPermission(permissionMapping[option.id.toString()])
        );

        // Initialize selectedCategory after filtering
        this.selectedCategory = this.categoryToggleOptions[0]?.id;
    }

    onDateFilterChange(): void {
        this.rerenderDT();
    }

    openReassignComponent() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(CereriAsigneazaComponent, {
                ...this.dialogService.getDialogConfig(),
                data: this.selectedRowIds,
            });

            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    openChangeStatusComponent() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(CereriStatusComponent, {
                ...this.dialogService.getDialogConfig(),
                data: this.selectedRowIds,
            });

            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    redirectTo(): void {
        const slug = 'someString';
        this.router.navigate([slug]);
    }

    downloadManual() {
        let fullPath = this.cereriService.downloadManualUrl;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('File download error: ', err);
                this.isLoading = false;
            })
    }

    onFiltreChange(event: MatButtonToggleChange) {
        this.selectedFiltre = event.value;
    }
}
